import React, { useEffect } from 'react';
import { useNavigate, generatePath, useParams } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import SubscribeScreen from './components/SubscribeScreen';
import KYCPendingScreen from './components/KYCPendingScreen';
import RequestAccessScreen from './components/RequestAccessScreen';
import Workspace from './components/Workspace';

import ROUTES_PATH from 'domain/router/routesPathConfig';

import useUserScreenFlow from './hooks/useUserScreenFlow';

const PaymentsWorkspace: React.FC = () => {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const {
    shouldRedirectToSettings,
    showSubscribeScreen,
    showKYCPendingScreen,
    showRequestAccessScreen,
    showWorkspace,
  } = useUserScreenFlow();

  useEffect(() => {
    if (shouldRedirectToSettings) {
      navigate(generatePath(ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.absolute, { companyId }));
    }
  }, [shouldRedirectToSettings, navigate, companyId]);

  return (
    <>
      {showWorkspace ? (
        <Workspace />
      ) : (
        <Stack justifyContent="center" alignItems="center" height="100%">
          {showSubscribeScreen && <SubscribeScreen />}
          {showKYCPendingScreen && <KYCPendingScreen />}
          {showRequestAccessScreen && <RequestAccessScreen />}
        </Stack>
      )}
    </>
  );
};

export default PaymentsWorkspace;
